module.exports = __webpack_public_path__ + "img/carbone.c8ec5554.jpeg";